import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Price from '../Product/Price';
import Button from '../Elements/Button/Button';
import { offset, height, scrollTo, addEvent, removeEvent, addClass, removeClass } from '../../utils/dom';
import { prefix, translate } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './InternalNavigation.scss';

const InternalNavigation = ({ productCache, sections, setup, product = false, customLink = false, productPage = false }) => {
	const specificProductCache = productCache && productCache[setup.market] && productCache[setup.market][setup.pricelist];
	if (product && product.length > 0 && !specificProductCache) return null;
	const cachedItem = product[0] && specificProductCache.products[product[0]] ? specificProductCache.products[product[0]] : null;

	const navigationClick = (e) => {
		e.preventDefault();
		const link = e.currentTarget.getAttribute('href').slice(1);

		if (document.getElementById(link)) {
			const scrollPosition = offset(document.getElementById(link)).top - 100;
			scrollTo(400, scrollPosition);
		}
	};

	useEffect(() => {
		if (!document.getElementById('productTop')) return () => {};
		const $html = document.querySelector('html');
		let intiateStickyButton = offset(document.getElementById('productTop')).top + height(document.getElementById('productTop'));
		let buttonIsSticky = false;

		const stickyBuyButton = () => {
			const top = window.pageYOffset || document.documentElement.scrollTop;
			if (top > intiateStickyButton && !buttonIsSticky) {
				buttonIsSticky = true;
				addClass($html, 'buyButtonIsFixed');
			} else if (top < intiateStickyButton && buttonIsSticky) {
				buttonIsSticky = false;
				removeClass($html, 'buyButtonIsFixed');
			}
		};

		const buyButtonPosition = () => {
			intiateStickyButton = offset(document.getElementById('productTop')).top + height(document.getElementById('productTop'));
		};

		addEvent(window, 'scroll.buyButton', () => {
			window.requestAnimationFrame(stickyBuyButton);
		});

		addEvent(window, 'resize.buyButtonPosition', () => {
			window.requestAnimationFrame(buyButtonPosition);
		});

		stickyBuyButton();

		return () => {
			removeEvent(window, 'scroll.buyButton');
			removeEvent(window, 'resize.buyButtonPosition');
		};
	});

	return (
		<div className={s.internalNavigation}>
			<div className={s.internalNavigation_fixed}>
				<div className={s.internalNavigation_links}>
					{
						sections.map((section) => (
							<a key={urlify(translate(setup, section.sectionTitle.text))} className={s.internalNavigation_link} href={`#${urlify(translate(setup, section.sectionTitle.text))}`} onClick={navigationClick}>{ translate(setup, section.sectionTitle.text) }</a>
						))
					}
				</div>
			</div>
			{
				cachedItem && (
					<div className={[s.internalNavigation_product, (productPage ? s.internalNavigation_product__productPage : null)].join(' ')}>
						{ !productPage && <Button type="link" location={prefix(setup, cachedItem.canonicalUri)} text={translate(setup, 'subMenuProductLink')} /> }
						<div className={s.internalNavigation_product_details}>
							<span>{ cachedItem.name }</span>
							<Price price={cachedItem.price} soldOut={!cachedItem.inStock ? translate(setup, 'soldOut') : false} />
						</div>
					</div>
				)
			}
			{
				!cachedItem && customLink && (
					<div className={[s.internalNavigation_product, (productPage && s.internalNavigation_product__productPage)].join(' ')}>
						{ customLink.link && <Button type="link" location={prefix(setup, customLink.link.url)} text={translate(setup, customLink.link.title)} /> }
						<div className={s.internalNavigation_product_details}>
							<div className={s.internalNavigation_product_details_text}>{ translate(setup, customLink.text) }</div>
						</div>
					</div>
				)
			}
		</div>
	);
};


const mapState = ({ productCache }, { ...props }) => ({
	productCache,
	...props,
});

export default hot(module)(connect(mapState)(InternalNavigation));
